import { SVGAttributes } from 'react';

export const PostMessageErrorIcon = ({ className, id, ...rootProps }: SVGAttributes<SVGSVGElement>) => (
    <svg width="146" height="148" viewBox="0 0 146 148" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M139.271 4.37813L8.12943 0.00450219C3.65029 -0.144909 0 3.44291 0 8.01879V140.212C0 144.788 3.65029 148.267 8.12943 147.984L139.271 139.693C142.995 139.458 146 135.91 146 131.768V12.1028C146 7.96053 142.995 4.50236 139.271 4.37813Z"
            fill="#333541"
        />
        <path
            opacity="0.74"
            d="M8.12982 145.352C5.08373 145.539 2.60547 143.171 2.60547 140.061V8.09115C2.60547 4.98163 5.08373 2.53918 8.12982 2.63557L139.271 6.78396C141.808 6.8642 143.859 9.21834 143.859 12.0423V131.891C143.859 134.715 141.808 137.13 139.271 137.286L8.12982 145.352Z"
            fill="white"
        />
        <path
            d="M139.271 4.37813L8.12952 0.00450218C3.65046 -0.144909 0 3.44291 0 8.01879V13.9623L146 17.483V12.1028C146 7.96053 142.995 4.50236 139.271 4.37813Z"
            fill="#333541"
        />
        <path
            d="M14.4416 7.62739C14.4416 9.11095 13.2656 10.2822 11.8123 10.2434C10.3562 10.2044 9.17383 8.96597 9.17383 7.47727C9.17383 5.98857 10.3562 4.81749 11.8123 4.86156C13.2656 4.90545 14.4416 6.14374 14.4416 7.62739Z"
            fill="white"
        />
        <path
            d="M23.607 7.88857C23.607 9.36327 22.445 10.5277 21.0091 10.4893C19.5706 10.4508 18.4023 9.22006 18.4023 7.74032C18.4023 6.26057 19.5705 5.09632 21.0091 5.13985C22.445 5.1833 23.607 6.41388 23.607 7.88857Z"
            fill="white"
        />
        <path
            d="M32.6621 8.14709C32.6621 9.613 31.5139 10.7706 30.0952 10.7326C28.6738 10.6947 27.5195 9.47139 27.5195 8.00051C27.5195 6.52963 28.6738 5.37222 30.0952 5.41522C31.514 5.45814 32.6621 6.68118 32.6621 8.14709Z"
            fill="white"
        />
        <g opacity="0.5">
            <path
                d="M85.1836 54.6216C70.527 31.9113 45.0137 39.3142 28.7787 14.0377C25.8428 9.46688 23.8494 4.81138 22.4815 0.515433L7.79423 0.00450219C3.49982 -0.144909 0 3.44291 0 8.01888V140.212C0 144.788 3.49974 148.267 7.79415 147.984L129 139.992C126.269 135.806 102.397 120.506 96.2038 96.3916C90.5305 74.3014 93.9971 68.2779 85.1836 54.6216Z"
                fill="white"
            />
        </g>
        <path
            opacity="0.5"
            d="M74.0107 108.642C68.1796 108.751 62.3722 107.359 57.2245 104.602C51.667 101.628 47.0122 97.1719 43.7855 91.7146C40.6581 86.4236 39 80.3554 39 74.1821C39 54.8208 54.9051 39.4978 74.0107 40.0126C92.6434 40.5147 107.465 55.9655 107.465 74.4663C107.465 92.9671 92.6434 108.295 74.0107 108.642Z"
            fill="white"
        />
        <path
            d="M104.569 74.4538C104.569 91.3802 91.0401 105.328 74.0082 105.612C68.4955 105.703 63.2825 104.356 58.7213 101.902C53.6641 99.1848 49.4255 95.11 46.499 90.1487C43.7404 85.4707 42.1543 80.0178 42.1543 74.1947C42.1543 56.552 56.5819 42.6076 74.0082 43.0421C91.0401 43.4668 104.569 57.5274 104.569 74.4538Z"
            fill="white"
        />
        <path
            d="M93.544 69.4406L93.5353 78.4307C93.5323 79.2919 93.1967 80.1143 92.5958 80.7216L85.0248 88.3984C84.4142 89.0154 83.5854 89.3663 82.7228 89.3654L71.264 89.3659C71.264 89.3659 63.3938 97.2234 58.7224 101.903C53.6651 99.185 49.4265 95.1102 46.5 90.1489C51.2157 85.4688 59.2893 77.4266 59.2893 77.4266L59.2432 65.772C59.24 64.8877 59.5944 64.041 60.2253 63.424L68.0459 55.7522C68.6669 55.1452 69.5063 54.8128 70.378 54.8276L79.4518 54.9885C80.2012 55.0012 80.8781 55.4683 81.1654 56.1697C81.4497 56.8738 81.291 57.6733 80.7614 58.1992L72.1156 66.765C71.3459 67.5259 71.3428 68.7764 72.1125 69.5531L75.2076 72.682L76.0608 73.5428L79.1398 76.6585C79.9016 77.4271 81.1357 77.4296 81.8954 76.6657L90.4297 68.1017C90.9525 67.5758 91.7378 67.424 92.4221 67.7173C93.1024 68.0104 93.547 68.69 93.544 69.4406Z"
            fill="#333541"
        />
    </svg>
);

PostMessageErrorIcon.displayName = 'PostMessageErrorIcon';
